export default __webpack_public_path__ + "static/contact-tab-one-8f4bc36c07f3d651ed96f4b8868c9752.jpg";